import { useMediaQuery, Theme, useTheme } from '@mui/material'
import { isMobilePortrait } from '../../../utils'

// FIXME decide which heuristic to use
// FIXME use hooks collection lib like react-use
export const useMobile = () => {
    const theme : Theme = useTheme()
    const mobileWidth = useMediaQuery(theme.breakpoints.down('md')) ?? isMobilePortrait()
    return mobileWidth;
}
